import axios from 'axios';
import config from '../common/config';

export default {
  /**
   * Process payment with SUMIT token
   * Matches Flask backend structure: { singleUseToken, customer, items }
   * @param {string} singleUseToken - The token from SUMIT
   * @param {object} customer - Customer information { name, email, phone }
   * @param {array} items - Array of items { name, description, quantity, unitPrice, currency }
   * @returns {Promise} API response
   */
  processPayment(singleUseToken, customer, items, options = {}) {
    // Match Flask backend structure exactly: { singleUseToken, customer, items }
    const payload = {
      singleUseToken: singleUseToken,
      customer: customer,
      items: items
    };

    if (options.rideId) {
      payload.rideId = options.rideId;
    }
    if (options.documentDescription) {
      payload.documentDescription = options.documentDescription;
    }
    
    return axios.post(`${config.config.ROOT_URL}/process_payment`, payload, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      return response.data;
    }).catch(error => {
      throw error;
    });
  }
};

